export function Pager({ page, pageSize, total, onChange }: {
  page: number; pageSize: number; total: number; onChange: (p: number) => void;
}) {
  const pages = Math.max(1, Math.ceil(total / pageSize));
  const from = total === 0 ? 0 : (page - 1) * pageSize + 1;
  const to = Math.min(page * pageSize, total);
  if (pages <= 1) {
    // 单页也展示条数信息，便于确认数据量
    return total > 0 ? <div className="pager"><span className="pager-info">共 {total} 条</span></div> : null;
  }
  const nums: number[] = [];
  for (let i = 1; i <= pages; i++) {
    if (i === 1 || i === pages || Math.abs(i - page) <= 2) nums.push(i);
  }
  const items: (number | "…")[] = [];
  nums.forEach((n, i) => {
    if (i > 0 && n - nums[i - 1] > 1) items.push("…");
    items.push(n);
  });
  return (
    <div className="pager">
      <button className="pager-btn" disabled={page <= 1} onClick={() => onChange(page - 1)}>←</button>
      {items.map((it, i) =>
        it === "…"
          ? <span key={`e${i}`} className="pager-ellipsis">…</span>
          : <button key={it} className={`pager-btn ${it === page ? "active" : ""}`} onClick={() => onChange(it)}>{it}</button>
      )}
      <button className="pager-btn" disabled={page >= pages} onClick={() => onChange(page + 1)}>→</button>
      <span className="pager-info">第 {from}–{to} 条 · 共 {total} 条</span>
    </div>
  );
}
